import RoofClaimsFrontHouse from '../RoofClaims/Roof-Claims-Front-House.jpg'
import RoofClaimsAddressVerification from '../RoofClaims/Roof-Claims-Address-Verification.jpg'
import RoofClaims3DView01 from '../RoofClaims/Roof-Claims-3D-View-01.jpg'
import RoofClaims3DView02 from '../RoofClaims/Roof-Claims-3D-View-02.jpg'
import RoofClaims3DView03 from '../RoofClaims/Roof-Claims-3D-View-03.jpg'
import RoofClaims3DView04 from '../RoofClaims/Roof-Claims-3D-View-04.jpg'
import RoofClaims3DView05 from '../RoofClaims/Roof-Claims-3D-View-05.jpg'
import RoofClaimsWiresHome from '../RoofClaims/Roof-Claims-Wires-Home.jpg'
import RoofClaimsSiding from '../RoofClaims/Roof-Claims-Siding.jpg'
import RoofClaimsOtherProperty from '../RoofClaims/Roof-Claims-Other-Property.jpg'
import RoofClaimsLayers from '../RoofClaims/Roof-Claims-Layers.jpg'
import RoofClaimsInclinationAngle from '../RoofClaims/Roof-Claims-Inclination-Angle.jpg'
import RoofClaimsOverview from '../RoofClaims/Roof-Claims-Overview.jpg'
import RoofClaimsOverview01 from '../RoofClaims/Roof-Claims-Overview-01.jpg'
import RoofClaimsOverview02 from '../RoofClaims/Roof-Claims-Overview-02.jpg'
import RoofClaimsOverview03 from '../RoofClaims/Roof-Claims-Overview-03.jpg'
import RoofClaimsOverview04 from '../RoofClaims/Roof-Claims-Overview-04.jpg'
import RoofClaimsGutters from '../RoofClaims/Roof-Claims-Gutters.jpg'
import RoofClaimsFlashing from '../RoofClaims/Roof-Claims-Chimney-Flashings.jpg'
import RoofClaimsPenetrations from '../RoofClaims/Roof-Claims-Penetrations.jpg'
import RoofClaimsHail from '../RoofClaims/Roof-Claims-Hail.jpg'
import RoofClaimsHail01 from '../RoofClaims/Roof-Claims-Hail-01.jpg'
import RoofClaimsHail02 from '../RoofClaims/Roof-Claims-Hail-02.jpg'
import RoofClaimsHail03 from '../RoofClaims/Roof-Claims-Hail-03.jpg'
import RoofClaimsHail04 from '../RoofClaims/Roof-Claims-Hail-04.jpg'
import RoofClaimsWindDamage01 from '../RoofClaims/Roof-Claims-Wind-Damage-01.jpg'
import RoofClaimsWindDamage02 from '../RoofClaims/Roof-Claims-Wind-Damage-02.jpg'
import RoofClaimsWindDamage03 from '../RoofClaims/Roof-Claims-Wind-Damage-03.jpg'
import RoofClaimsLengthShingle from '../RoofClaims/Roof-Claims-Length-Shingle.jpg'
import RoofClaimsLengthShingle01 from '../RoofClaims/Roof-Claims-Length-Shingle-01.jpg'
import RoofClaimsDripEdge from '../RoofClaims/Roof-Claims-Drip-Edge.jpg'
import RoofClaimsShinglesColor from '../RoofClaims/Roof-Claims-Shingles-Color.jpg'
import RoofClaimsGarage from '../RoofClaims/Roof-Claims-Garage.jpg'

import type { MediaKind } from '../../../../common/schema'

import { ExampleImage } from '..'

// Keep in sync with src/web/img/RoofClaims/index.ts (same labels, same files,
// same order) - roofClaimExamples.test.ts compares both.

export const ROOF_CLAIMS_FRONT_HOUSE: ExampleImage[] = [
  {
    label: 'Front of the house',
    source: RoofClaimsFrontHouse,
  },
]

export const ROOF_CLAIMS_ADDRESS_VERIFICATION: ExampleImage[] = [
  {
    label: 'Address Verification',
    source: RoofClaimsAddressVerification,
  },
]

export const ROOF_CLAIMS_3D_VIEW: ExampleImage[] = [
  {
    label: '3D View (1)',
    source: RoofClaims3DView01,
  },
  {
    label: '3D View (2)',
    source: RoofClaims3DView02,
  },
  {
    label: '3D View (3)',
    source: RoofClaims3DView03,
  },
  {
    label: '3D View (4)',
    source: RoofClaims3DView04,
  },
  {
    label: '3D View (5)',
    source: RoofClaims3DView05,
  },
]

export const ROOF_CLAIMS_WIRES_HOME: ExampleImage[] = [
  {
    label: 'Wires in to home',
    source: RoofClaimsWiresHome,
  },
]

// Monday 13386495658 (Jaron 2026-10-25): the wind-torn siding photo was the
// Wind damage example; "This would be under siding", so it leads here.
export const ROOF_CLAIMS_SIDING: ExampleImage[] = [
  {
    label: 'Siding (wind damage)',
    source: RoofClaimsOtherProperty,
  },
  {
    label: 'Siding (Damage, Asbestos)',
    source: RoofClaimsSiding,
  },
]

// Original 2024 example (f43f2cf8). No gazebo/fence photo exists yet.
export const ROOF_CLAIMS_OTHER_PROPERTY: ExampleImage[] = [
  {
    label: 'Other Property wind damage (Gazebo, faceline, tramp)',
    source: RoofClaimsOtherProperty,
  },
]

// Jaron's own photos (2026-10-25). Before this the category reused the
// property damage example (7d987d74) and never had one of its own.
export const ROOF_CLAIMS_WIND_DAMAGE: ExampleImage[] = [
  {
    label: 'Wind damage (missing / lifted shingles on the roof)',
    source: RoofClaimsWindDamage01,
  },
  {
    label: 'Wind damage (missing shingles)',
    source: RoofClaimsWindDamage02,
  },
  {
    label: 'Wind damage (missing shingles)',
    source: RoofClaimsWindDamage03,
  },
]

export const ROOF_CLAIMS_LAYERS: ExampleImage[] = [
  {
    label: 'Layers (lift up)',
    source: RoofClaimsLayers,
  },
]

export const ROOF_CLAIMS_ROOF_INCLINATION: ExampleImage[] = [
  {
    label: 'Roof inclination angle (Pitch gauge tool)',
    source: RoofClaimsInclinationAngle,
  },
]

export const ROOF_CLAIMS_ROOF_OVERVIEW: ExampleImage[] = [
  {
    label: 'Roof overview (1)',
    source: RoofClaimsOverview01,
  },
  {
    label: 'Roof overview (2)',
    source: RoofClaimsOverview02,
  },
  {
    label: 'Roof overview (3)',
    source: RoofClaimsOverview03,
  },
  {
    label: 'Roof overview (4)',
    source: RoofClaimsOverview04,
  },
  {
    label:
      'Roof Overview (Line through damage. wiring, masts, chimmeney, --vents, pipes)',
    source: RoofClaimsOverview,
  },
]

export const ROOF_CLAIMS_GUTTER: ExampleImage[] = [
  {
    label: 'Gutters (show how were fastened to the roof)',
    source: RoofClaimsGutters,
  },
]

export const ROOF_CLAIMS_FLASHING: ExampleImage[] = [
  {
    label: 'Flashing',
    source: RoofClaimsFlashing,
  },
]

export const ROOF_CLAIMS_PENETRATIONS: ExampleImage[] = [
  {
    label: 'Penetrations (pipejacks, turtlevents, satellite, solar)',
    source: RoofClaimsPenetrations,
  },
]

export const ROOF_CLAIMS_HAIL: ExampleImage[] = [
  {
    label: 'Hail damage (1)',
    source: RoofClaimsHail01,
  },
  {
    label: 'Hail damage (2)',
    source: RoofClaimsHail02,
  },
  {
    label: 'Hail damage (3)',
    source: RoofClaimsHail03,
  },
  {
    label: 'Hail damage (4)',
    source: RoofClaimsHail04,
  },
  {
    label: 'Hail damage (if applicable)',
    source: RoofClaimsHail,
  },
]

// Jaron 2026-10-25: "Make this first picture and shingle length".
export const ROOF_CLAIMS_LENGTH_SHINGLE: ExampleImage[] = [
  {
    label: 'Shingle length (measuring tape)',
    source: RoofClaimsLengthShingle01,
  },
  {
    label: 'Shingle length (measuring tape)',
    source: RoofClaimsLengthShingle,
  },
]

export const ROOF_CLAIMS_DRIP: ExampleImage[] = [
  {
    label: 'Drip edge',
    source: RoofClaimsDripEdge,
  },
]

export const ROOF_CLAIMS_SHINGLES_COLOR: ExampleImage[] = [
  {
    label: 'Shingles color',
    source: RoofClaimsShinglesColor,
  },
]

export const ROOF_CLAIMS_GARAGE: ExampleImage[] = [
  {
    label: 'Garage',
    source: RoofClaimsGarage,
  },
]

// The "?" example for every listed roof claim photo row. rc_ice_shield is
// retired (Jaron 2026-10-25) and has none.
export const ROOF_CLAIMS_EXAMPLES: Partial<Record<MediaKind, ExampleImage[]>> =
  {
    rc_front_house: ROOF_CLAIMS_FRONT_HOUSE,
    rc_address_verification: ROOF_CLAIMS_ADDRESS_VERIFICATION,
    rc_3d_view: ROOF_CLAIMS_3D_VIEW,
    rc_garage: ROOF_CLAIMS_GARAGE,
    rc_wires_home: ROOF_CLAIMS_WIRES_HOME,
    rc_siding: ROOF_CLAIMS_SIDING,
    rc_layers: ROOF_CLAIMS_LAYERS,
    rc_roof_inclination: ROOF_CLAIMS_ROOF_INCLINATION,
    rc_roof_overview: ROOF_CLAIMS_ROOF_OVERVIEW,
    rc_drip_edge: ROOF_CLAIMS_DRIP,
    rc_gutters: ROOF_CLAIMS_GUTTER,
    rc_flashings: ROOF_CLAIMS_FLASHING,
    rc_penetrations: ROOF_CLAIMS_PENETRATIONS,
    rc_hail: ROOF_CLAIMS_HAIL,
    rc_other_property_wind_damage: ROOF_CLAIMS_OTHER_PROPERTY,
    rc_wind_damages: ROOF_CLAIMS_WIND_DAMAGE,
    rc_length_shingle: ROOF_CLAIMS_LENGTH_SHINGLE,
    rc_shingles_color: ROOF_CLAIMS_SHINGLES_COLOR,
  }
